import { render, staticRenderFns } from "./ImageGalleryPanel.vue?vue&type=template&id=7796b188&scoped=true"
import script from "./ImageGalleryPanel.vue?vue&type=script&lang=js"
export * from "./ImageGalleryPanel.vue?vue&type=script&lang=js"
import style0 from "./ImageGalleryPanel.vue?vue&type=style&index=0&id=7796b188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7796b188",
  null
  
)

export default component.exports